import { attributes } from '../../core/ids-attributes';

export type IdsButtonContentAlignment = 'default' | 'start' | 'end';
export type IdsButtonIconAlignment = undefined | 'start' | 'end';
export type IdsButtonAppearance = 'default' | 'primary' | 'secondary' | 'tertiary' | 'primary-destructive' | 'tertiary-destructive' | 'swipe-action-right' | 'swipe-action-left' | 'primary-generative-ai' | 'tertiary-generative-ai' | 'secondary-generative-ai';

// Button Appearance types
export const BUTTON_APPEARANCE: Array<IdsButtonAppearance> = [
  'default',
  'primary',
  'secondary',
  'tertiary',
  'primary-destructive',
  'tertiary-destructive',
  'swipe-action-left',
  'swipe-action-right',
  'primary-generative-ai',
  'tertiary-generative-ai',
  'secondary-generative-ai'
];

export const BUTTON_CONTENT_ALIGNMENTS: Array<IdsButtonContentAlignment> = [
  'default',
  'start',
  'end'
];

export type IdsButtonType = HTMLButtonElement['type'];

// HTMLButtonElement types
export const BUTTON_TYPES: Array<string> = [
  'button', 'submit', 'reset', 'menu'
];

// Default Button state values
export const BUTTON_DEFAULTS: any = {
  contentAlign: BUTTON_CONTENT_ALIGNMENTS[0],
  cssClass: [],
  disabled: false,
  hidden: false,
  tabIndex: 0,
  iconAlign: undefined,
  appearance: BUTTON_APPEARANCE[0]
};

// Definable attributes
export const BUTTON_ATTRIBUTES: string[] = [
  attributes.APPEARANCE,
  attributes.COMPACT,
  attributes.CONTENT_ALIGN,
  attributes.CSS_CLASS,
  attributes.DISABLED,
  attributes.HEIGHT,
  attributes.HIDDEN,
  attributes.ICON,
  attributes.ICON_ALIGN,
  attributes.ID,
  attributes.LABEL,
  attributes.LABEL_AUDIBLE,
  attributes.LABEL_WIDTH,
  attributes.LABEL_POSITION,
  attributes.SIZE,
  attributes.NO_ANIMATION,
  attributes.NO_PADDING,
  attributes.MARGIN_BLOCK_END,
  attributes.NO_MARGINS,
  attributes.SQUARE,
  attributes.TEXT,
  attributes.TYPE,
  attributes.TABINDEX,
  attributes.WIDTH,
  attributes.BADGE_COLOR,
  attributes.BADGE_POSITION,
  attributes.OVERFLOW,
  attributes.OVERFLOW_TOOLTIP
];

// Icon alignment CSS class names
export const ICON_ALIGN_CLASSNAMES = [
  'align-icon-start',
  'align-icon-end'
];

// IdsButton CSS classes representing button types
export const baseProtoClasses = [
  'ids-button',
  'ids-icon-button',
  'ids-menu-button',
  'ids-toggle-button'
];

// List of flex options
export const BUTTON_GROUP_FLEX_OPTIONS = {
  direction: ['row', 'row-reverse', 'column', 'column-reverse'],
  display: ['flex', 'inline-flex'],
  justifyContent: ['start', 'stretch', 'end', 'flex-start', 'flex-end', 'center', 'left', 'right', 'space-between', 'space-around', 'space-evenly'],
};
